import './App.css';
import { AuthProvider } from './context/AuthContext';
import Home from './screen/Home'
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Toaster />
      <AuthProvider>
        <Home />
      </AuthProvider>
    </>
  );
}

export default App;
